import { useEffect, useState } from "react";
import { Box, Flex, IconButton, Image, Stack } from "@chakra-ui/react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import HomeIcon from "../../assets/images/home.svg"
import DepartIcon from "../../assets/images/Department.svg";
import EmployeeIcon from "../../assets/images/EmployeeIcon.svg";
import TaxIcon from "../../assets/images/TaxIcon.svg";
import OnboardingIcon from "../../assets/images/Onboarding_Logo.svg";
import PendingApprovalsIcon from "../../assets/images/PendingApprovalsIcon.svg";
import LeaveCalendarIcon from "../../assets/images/LeaveCalender.svg";
import AttendenceIcon from "../../assets/images/AttendanceIcon.svg";
import MettingIcon from "../../assets/images/mettingIcon.svg";
import TeamManagementIcon from "../../assets/images/teamManagementIcon.svg";
import MyAttendenceIcon from "../../assets/images/MyAttendanceIcon.svg";
import PayrollIcon from "../../assets/images/Payroll.svg";
import DirectorsIcon from "../../assets/images/DirectorsIcon.svg";
import DirectorDocumentsIcon from "../../assets/images/DirectorDocumentsIcon.svg";
import IncrementSettingIcon from "../../assets/images/IncrementSettingIcon.svg";
import IncrementIcon from "../../assets/images/IncrementIcon.svg";
import PayrollReleaseIcon from "../../assets/images/PayrollReleaseIcon.svg";
import CollapseIcon from "../../assets/images/CollapseOn.svg";
import SupportIcon from "../../assets/images/support.svg";
import AssetICon from "../../assets/images/fluent_building-cloud-24-regular (1).svg";
import ReportIcon from "../../assets/images/ReportIcon.svg";
import DocumentIcon from "../../assets/images/document.svg";
import JobOpeningIcon from "../../assets/images/JobOpeningIcon.svg";
import Logo from "../../assets/images/hrms_logo.svg";
import CollapseLogo from "../../assets/images/CollapseLogo.svg"
import AdminControl from "../../assets/images/AdminControlIcon.svg";
import TaskIcon from "../../assets/images/TaskIcon.svg"
import AwardCerticicateIcon from "../../assets/images/Award&CeritifateIcon.svg"
import * as routesNames from "../../constants/routes";
import MyDiv from "./sidebar.style";
import { useAuth } from "../../hooks/useAuth";
import Welcomeicon from "../../assets/images/welcomeicon.svg";
import { assert } from "console";

type SubMenuItem = {
  id: number;
  label: string;
  link: string;
};

type MenuItem = {
  id: number;
  menuName: string;
  menuLogo: string;
  link?: string;
  subMenu?: SubMenuItem[];
};

interface sidebarProps {
  toggleSidebar: any,
  handleSidePanel: any,
  activePortal: any
}

const Sidebar = (props: sidebarProps) => {
  const location = useLocation();
  const route = location.pathname.split("/")[1];
  const isMasterRoute = route === "master";
  const Menus: MenuItem[] = [];
  const RequirementMenus: MenuItem[] = [];
  const ConsumerMenus: MenuItem[] = [];
  // const menus = props.activePortal === "hrlense" ? Menus : RequirementMenus ;
  const menus =
    props.activePortal === "hrlense" ? Menus : props.activePortal === "Recruitment" ? RequirementMenus : ConsumerMenus;

  const { hasPermission, loginObj } = useAuth();
  const [menuId, setMenuId] = useState<number | null>(null);

  if (hasPermission('Dashboard'))
    Menus.push({ id: 1, menuName: "Dashboard", menuLogo: HomeIcon, link: routesNames.DASHBOARD, });
  if (hasPermission('Department'))
    Menus.push({ id: 2, menuName: "Department", menuLogo: DepartIcon, link: routesNames.ADMINDEPARTMENT, });

  if (hasPermission('Employee', "showEmployee"))
    Menus.push({ id: 3, menuName: "Employees", menuLogo: EmployeeIcon, link: routesNames.EMPLOYEES, });

  if (hasPermission('EmployeeOnboarding')) {
    Menus.push({id: 38,menuName: "Onboarding Approvals",menuLogo: PendingApprovalsIcon,link: routesNames.ONBOARDINGAPPROVAL,});
  }


  if (hasPermission('Management Interaction') || hasPermission('Member Interaction')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Management Interaction')) SubMenu.push({ id: 18, label: 'Management Interaction', link: routesNames.MANAGEMENTINTRACTION, });
    if (hasPermission('Member Interaction')) SubMenu.push({ id: 19, label: 'Member Interaction', link: routesNames.MEMBERINTRACTION, });
    Menus.push({ id: 20, menuName: "Team-Management", menuLogo: TeamManagementIcon, subMenu: SubMenu });
  }

  if (hasPermission('MeetingsManagement')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('MeetingsManagement')) SubMenu.push({ id: 180, label: 'Meetings Management', link: routesNames.MEETINGSMANAGEMENT, });
    if (hasPermission('MyMeeting')) SubMenu.push({ id: 181, label: 'My Meeting', link: routesNames.MYMEETING, });
    Menus.push({ id: 21, menuName: "Meetings", menuLogo: MettingIcon, subMenu: SubMenu, });
  }

  if (hasPermission('AttendanceSheet') || hasPermission('ManualAttendance') || hasPermission('LeavesRequest') || hasPermission('LeavesBalance') || hasPermission('Regularisation') || hasPermission('Holidays') || hasPermission('AttendanceReportPage')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('AttendanceSheet')) SubMenu.push({ id: 41, label: 'Attendance Sheet', link: routesNames.ATTENDANCESHEET, });
    if (hasPermission('AttendanceReportPage')) SubMenu.push({ id: 49, label: 'Attendance Report', link: routesNames.ATTENDANCEREPORTPage, });
    if (hasPermission('ManualAttendance')) SubMenu.push({ id: 42, label: 'Manual Attendance', link: routesNames.MANUALATTENDANCE, });
    if (hasPermission('LeavesRequest')) SubMenu.push({ id: 43, label: 'Leaves Request', link: routesNames.LEAVESREQUEST, });
    if (hasPermission('LeavesBalance')) SubMenu.push({ id: 44, label: 'Leaves Balance', link: routesNames.LEAVESBALANCE, });
    if (hasPermission('Regularisation')) SubMenu.push({ id: 45, label: 'Regularisation', link: routesNames.REGULARISATION, });
    if (hasPermission('RemoteApproval')) SubMenu.push({ id: 46, label: 'Remote Request', link: routesNames.REMOTEAPPROVAL, });
    if (hasPermission('RemoteWorkTimeApproval')) SubMenu.push({ id: 47, label: 'Remote Work Time', link: routesNames.REMOTEWORKTIMEAPPROVAL, });
    if (hasPermission('Holidays')) SubMenu.push({ id: 48, label: 'Holidays', link: routesNames.HOLIDAYS, });
    if (hasPermission('Absence Management')) SubMenu.push({ id: 49, label: 'Absence Management', link: routesNames.ABSENCEMANAGEMENT, });
    Menus.push({ id: 4, menuName: "Attendance", menuLogo: AttendenceIcon, subMenu: SubMenu, });
  }


  if (hasPermission('InvestmentDeclaration') || hasPermission('ProofofInvestment')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('InvestmentDeclaration')) SubMenu.push({ id: 61, label: 'Investment Declaration', link: routesNames.TAXDECLARATION, });
    if (hasPermission('ProofofInvestment')) SubMenu.push({ id: 62, label: 'Proof of Investment', link: routesNames.PROOFOFINVESTMENT, });
    Menus.push({ id: 6, menuName: "Tax & Compliance", menuLogo: TaxIcon, subMenu: SubMenu, });
  }

  if (hasPermission('Roles') || hasPermission('Users') || hasPermission('Pages') || hasPermission('LeaveManagement') || hasPermission("TicketGroup") || hasPermission('RegularizationApprovalSetting') || hasPermission('EmailTemplate') || hasPermission("CrossCompanyHierarchy") || hasPermission("EmailSetting") || hasPermission("SalaryCalculationSetting")) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Roles')) SubMenu.push({ id: 71, label: 'Roles', link: routesNames.ROLES, });
    if (hasPermission('Users')) SubMenu.push({ id: 72, label: 'Users', link: routesNames.USERS, });
    if (hasPermission('Pages')) SubMenu.push({ id: 73, label: 'Pages', link: routesNames.PAGES, });
    if (hasPermission('LeaveManagement')) SubMenu.push({ id: 74, label: 'Approval Setting', link: routesNames.LEAVEMANAGEMENT, });
    if (hasPermission('RegularizationApprovalSetting')) SubMenu.push({ id: 75, label: 'Regularization Approval Setting', link: routesNames.REGULARIZATIONAPPROVALSETTING, });
    if (hasPermission('attendanceSetting')) SubMenu.push({ id: 76, label: 'Attendance Setting', link: routesNames.ATTENDANCESETTING, });
    if (hasPermission('EmailTemplate')) SubMenu.push({ id: 77, label: 'Email Template', link: routesNames.EMAILTEMPLATE, });
    if (hasPermission("TicketGroup")) SubMenu.push({ id: 78, label: 'Ticket Group', link: routesNames.TICKETGROUP, })
    if (hasPermission("CrossCompanyHierarchy")) SubMenu.push({ id: 78, label: 'Cross Company Hierarchy', link: routesNames.GROUPHIERARCHY, })
    if (hasPermission("ApplicationGroup")) SubMenu.push({ id: 79, label: 'Application Group', link: routesNames.APPLICATIONGROUP, })
    if (hasPermission("Employee Exit Responsibility")) SubMenu.push({ id: 79, label: 'Employee Exit Responsibility', link: routesNames.EMPLOYEEEXITRESPONSIBILITY, })
    if (hasPermission("EmailSetting")) SubMenu.push({ id: 81, label: 'Email Setting', link: routesNames.EMAILSETTING, })
    if (hasPermission("HrAssignementSummary")) SubMenu.push({ id: 82, label: 'Hr Assignement Summary', link: routesNames.HRASSIGNEMENTSUMMARY, })
    if (hasPermission("HrManualAssignment")) SubMenu.push({ id: 83, label: 'Hr Manual Assignment', link: routesNames.HRMANUALASSIGNMENT, })
    if (hasPermission("SalaryCalculationSetting")) SubMenu.push({ id: 84, label: 'Salary Calculation Setting', link: routesNames.SALARYCALCULATIONSETTING, })
    if (hasPermission("Roles")) SubMenu.push({ id: 85, label: 'Offer Letter Template ', link: routesNames.OFFERLETTERTEMPLATE, });
    if (hasPermission("Roles")) SubMenu.push({ id: 86, label: 'Appointment Letter Template', link: routesNames.APPOINTMENTLETTERTEMPLATE, });
    if (hasPermission("Absence Setting")) SubMenu.push({ id: 87, label: 'Absence Setting', link: routesNames.ABSENCESETTINGS, });
    if (hasPermission("BulkUpdate")) SubMenu.push({ id: 137, label: 'Bulk Update Employee', link: routesNames.BULKUPDATE, });
    Menus.push({ id: 7, menuName: "Admin Control", menuLogo: AdminControl, subMenu: SubMenu, });
  }


  if (hasPermission("IncrementSetting", " WeightageConfiguration") || hasPermission('IncrementSetting', 'IncrementAssessmentApproval') || hasPermission('IncrementSetting', 'EmployeeCategory') || hasPermission('IncrementSetting', 'SalesRecruiterEfforts') || hasPermission('IncrementSetting', 'Disciplinesetting') || hasPermission('IncrementSetting', 'PerfomanceMatrix') || hasPermission('IncrementSetting', 'Incrementslab') || (hasPermission('IncrementSetting', 'AssessmentSetting'))) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('IncrementSetting', 'WeightageConfiguration')) SubMenu.push({ id: 701, label: 'Weightage Configuration', link: routesNames.WEIGHTAGECONFIGURATION, });
    if (hasPermission('IncrementSetting', 'Incrementslab')) SubMenu.push({ id: 703, label: 'Increment Slab', link: routesNames.INCREMENTSLABSETTING, });
    if (hasPermission('IncrementSetting', 'Disciplinesetting')) SubMenu.push({ id: 704, label: 'Discipline Setting', link: routesNames.DISCIPLINESETTING, });
    // if (hasPermission('IncrementSetting', 'GeneralSetting')) SubMenu.push({ id: 705, label: 'General Setting', link: routesNames.INCREMENTGENERALSETTING, });
    if (hasPermission('IncrementSetting', 'EmployeeCategory')) SubMenu.push({ id: 706, label: 'Employee Category', link: routesNames.EMPLOYEECATEGORY, });
    if (hasPermission('IncrementSetting', 'AssessmentSetting')) SubMenu.push({ id: 709, label: 'Assessment Setting', link: routesNames.ASSESSMENTSSETTING, });
    if (hasPermission('IncrementSetting', 'IncrementAssessmentApproval')) SubMenu.push({ id: 708, label: 'Assessment Approval', link: routesNames.INCREMENTASSESSMANTAPPROVAL, });
    if (hasPermission('IncrementSetting', 'PerfomanceMatrix')) SubMenu.push({ id: 702, label: 'Performance Matrix', link: routesNames.PERFOMANCEMATRIX, });
    if (hasPermission('IncrementSetting', 'SalesRecruiterEfforts')) SubMenu.push({ id: 707, label: 'Efforts or commitments', link: routesNames.SALESRECRUITEREFFORT, });
    if (hasPermission('IncrementSetting', 'AssessmentByPass')) SubMenu.push({ id: 710, label: 'Assessment Bypass', link: routesNames.ASSESSMENTBYPASS, });

    Menus.push({ id: 70, menuName: "Increment Setting", menuLogo: IncrementSettingIcon, subMenu: SubMenu, });
  }

  if (hasPermission("Increment")) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Increment', 'Assessment')) SubMenu.push({ id: 20010, label: 'Assesment', link: routesNames.RUNMANAGERASSESMENT, });
    if (hasPermission('Increment', 'EligibilityOverride')) SubMenu.push({ id: 20010, label: 'Eligibility Override', link: routesNames.ELIGIBILITYOVERRIDE, });
    if (hasPermission('IncrementSetting', 'ManagerAssesment')) SubMenu.push({ id: 708, label: 'Team Assessment', link: routesNames.MANAGERTEAMASSESMENT, });
    if (hasPermission('Increment', 'ApproveAssessment')) SubMenu.push({ id: 20010, label: 'Assessment Approval', link: routesNames.ASSESSMENTAPPROVAL, });
    if (hasPermission('Increment', 'IncrementCalculation')) SubMenu.push({ id: 20011, label: 'Increment Calculation', link: routesNames.APPRAISALDASHBOARD, });
    if (hasPermission('Increment', 'AppraisalActionPage')) SubMenu.push({ id: 20011, label: 'Appraisal Action', link: routesNames.APPRAISALACTIONSPAGE, });
    Menus.push({ id: 2001, menuName: "Increment", menuLogo: IncrementIcon, subMenu: SubMenu, });
  }

  const MasterMenus: MenuItem[] = [];
  if (hasPermission('Master') || loginObj?.roleId?.some((r: number) => [1, 2, 7].includes(r))) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Master', 'Branch')) SubMenu.push({ id: 81, label: 'Branch', link: routesNames.BRANCH, });
    if (hasPermission('Master', 'Department')) SubMenu.push({ id: 82, label: 'Department', link: routesNames.MASTERDEPARTMENT, });
    if (hasPermission('Master', 'Industry Type')) SubMenu.push({ id: 83, label: 'IndustryType', link: routesNames.INDUSTRYTYPE, });
    if (hasPermission('Master', 'Bank Name')) SubMenu.push({ id: 84, label: 'Bank Name', link: routesNames.BANKNAME, });
    if (hasPermission('Master', 'Company')) SubMenu.push({ id: 85, label: 'Company', link: routesNames.COMPANY, });
    if (hasPermission('Master', 'Blood Group')) SubMenu.push({ id: 86, label: 'Blood Group', link: routesNames.BLOODGROUP, });
    if (hasPermission('Master', 'Degree')) SubMenu.push({ id: 87, label: 'Degree', link: routesNames.DEGREE, });
    if (hasPermission('Master', 'Gender')) SubMenu.push({ id: 88, label: 'Gender', link: routesNames.GENDER, });
    if (hasPermission('Master', 'Marital Status')) SubMenu.push({ id: 89, label: 'Marital Status', link: routesNames.MARITALSTATUS, });
    if (hasPermission('Master', 'Score')) SubMenu.push({ id: 90, label: 'Score', link: routesNames.SCORE, });
    if (hasPermission('Master', 'Shift')) SubMenu.push({ id: 91, label: 'Shift', link: routesNames.SHIFT, });
    if (hasPermission('Master', 'Reference')) SubMenu.push({ id: 92, label: 'Reference', link: routesNames.REFERENCE, });
    if (hasPermission('Master', 'Relation')) SubMenu.push({ id: 93, label: 'Relation', link: routesNames.RELATION, });
    if (hasPermission('Master', 'Payroll Company')) SubMenu.push({ id: 94, label: 'Payroll Company', link: routesNames.PAYROLLCOMPANY, });
    if (hasPermission('Master', 'Leave Master')) SubMenu.push({ id: 95, label: 'Leave Master', link: routesNames.LEAVEMASTER, });
    if (hasPermission('Master', 'Job Profile')) SubMenu.push({ id: 96, label: 'Job Profile', link: routesNames.JOBPROFILE, });
    if (hasPermission('Master', 'Business Process')) SubMenu.push({ id: 97, label: 'Business Process', link: routesNames.BUSINESSPROCESS, });
    if (hasPermission('Master', 'Holiday Master')) SubMenu.push({ id: 98, label: 'Holiday Master', link: routesNames.HOLIDAYMASTER, });
    if (hasPermission('Master', 'Balance Leave')) SubMenu.push({ id: 99, label: 'Balance Leave', link: routesNames.BALANCELEAVE, });
    if (hasPermission('Master', 'Employee Status')) SubMenu.push({ id: 100, label: 'Employee Status', link: routesNames.EMPLOYEESTATUS, });
    if (hasPermission('Master', 'Candidate Master')) SubMenu.push({ id: 101, label: 'Candidate Master', link: routesNames.CANDIDATEMASTER, });
    if (hasPermission('Master', 'Education Degree')) SubMenu.push({ id: 102, label: 'Education Degree', link: routesNames.EDUCATIONDEGREE, });
    if (hasPermission('Master', 'Education Category')) SubMenu.push({ id: 103, label: 'Education Category', link: routesNames.EDUCATIONCATEGORIES, });
    if (hasPermission('Master', 'Thought Of The Day')) SubMenu.push({ id: 104, label: 'Thought Of The Day', link: routesNames.THOUGHTOFTHEDAY, });
    if (hasPermission('Master', 'Announcement')) SubMenu.push({ id: 105, label: 'Announcement', link: routesNames.ANNOUNCEMENT, });
    if (hasPermission('Master', 'Document Category')) SubMenu.push({ id: 106, label: 'Document Category', link: routesNames.DocumentCategory, });
    if (hasPermission('Master', 'Leave Reason')) SubMenu.push({ id: 107, label: 'Leave Reason', link: routesNames.LEAVEREASON, });
    if (hasPermission('Master', 'Termination Type')) SubMenu.push({ id: 108, label: 'Termination Type', link: routesNames.TERMINATIONTYPE, });
    if (hasPermission('Master', 'Regularization Setting')) SubMenu.push({ id: 110, label: 'Regularization Setting', link: routesNames.REGULARIZATIONSETTING, });
    if (hasPermission('Master', 'Exit Clearance Task Master')) SubMenu.push({ id: 111, label: 'Exit Clearance Task Master', link: routesNames.EXITCLEARANCETASKMASTER, });
    if (hasPermission('Master', 'Resignation Email Setting')) SubMenu.push({ id: 112, label: 'Resignation Email Setting', link: routesNames.RESIGNATIONEMAILSETTING, });
    if (hasPermission('Master', 'Notice Period')) SubMenu.push({ id: 113, label: 'Notice Period', link: routesNames.NOTICEPERIOD, });
    if (hasPermission('Master', 'Separation Reason')) SubMenu.push({ id: 115, label: 'Separation Reason', link: routesNames.SEPARATIONREASON, });
    if (hasPermission('Master', 'Job Skills')) SubMenu.push({ id: 116, label: 'Job Skills', link: routesNames.JOBSKILLS, });
    if (hasPermission('Master', 'Award & Certificate Category')) SubMenu.push({ id: 117, label: 'Award & Certificate Category', link: routesNames.AWARDSCERTIFICATECATEGORY, });
    if (hasPermission('Master', 'IVR Call Master')) SubMenu.push({ id: 118, label: 'IVR Call Master', link: routesNames.IVRCALLING, });
    if (hasPermission('Master', 'Discipline Setting')) SubMenu.push({ id: 119, label: 'Discipline Setting', link: routesNames.DISCIPLINESETTING, });
    if (hasPermission('Master', 'Increment Slab Setting')) SubMenu.push({ id: 120, label: 'Increment Slab Setting', link: routesNames.INCREMENTSLABSETTING, });
    if (hasPermission('Master', 'TDS Slab')) SubMenu.push({ id: 121, label: 'TDS Slab', link: routesNames.TDSLAB, });
    if (hasPermission('Master', 'Code Of Conduct')) SubMenu.push({ id: 124, label: 'Code Of Conduct', link: routesNames.CODEOFCONDUCT, });
    if (hasPermission('Master', 'Project')) SubMenu.push({ id: 126, label: 'Project', link: routesNames.PROJECT, });
    if (hasPermission('Master', 'CompanyDocumentCategory')) SubMenu.push({ id: 127, label: 'CompanyDocumentCategory', link: routesNames.COMPANYDOCUMENTCATEGORY, });
    if (hasPermission('Master', 'GroupMail')) SubMenu.push({ id: 128, label: 'Group Mail', link: routesNames.GROUPMAIL, });
    if (hasPermission('Master', 'AssestMaster')) SubMenu.push({ id: 128, label: 'Asset Master', link: routesNames.ASSETMASTER, });
    if (hasPermission('Master', 'CompanyDocument')) SubMenu.push({ id: 127, label: 'Company Document', link: routesNames.COMPANYDOCUMENT, });
    if (hasPermission('Master', 'Branch')) SubMenu.push({ id: 127, label: 'Branch Group', link: routesNames.BRANCHGROUP, });
    if (hasPermission('Master', 'Location')) SubMenu.push({ id: 129, label: 'Location', link: routesNames.LOCATION, });
    if (hasPermission('Directors')) SubMenu.push({ id: 131, label: 'Directors', link: routesNames.DIRECTORS, });
    if (hasPermission('DirectorDocuments')) SubMenu.push({ id: 132, label: 'Directors Documents', link: routesNames.DIRECTORDOCUMENTS, });
    if (hasPermission('Master', 'WebSiteSetting')) SubMenu.push({ id: 133, label: 'WebSiteSetting', link: routesNames.WEBSITESETTING, });
    if (hasPermission('Master', 'IdeaTargetType')) SubMenu.push({ id: 134, label: 'IdeaTargetType', link: routesNames.IDEATARGETTYPE, });
    if (hasPermission('Master', 'IdeaCategory')) SubMenu.push({ id: 135, label: 'Idea Category', link: routesNames.IDEACATEGORY, });
    if (hasPermission('Master', 'GroupEmailSetting')) SubMenu.push({ id: 136, label: 'GroupEmail Setting', link: routesNames.GROUPEMAILSETTING, });
     if (hasPermission('Master', 'AttendanceMaster')) SubMenu.push({ id: 140, label: 'Attendance Master', link: routesNames.ATTENDANCMASTER, });
    if (hasPermission('Master', 'CRM Mapping') || hasPermission('Master', 'Company')) SubMenu.push({ id: 137, label: 'CRM Mapping', link: routesNames.CRMMAPPING, });
    if (hasPermission('Master', 'Induction Policy') || hasPermission('Master', 'Company') || hasPermission('Master', 'Induction Master')) SubMenu.push({ id: 138, label: 'Induction Master', link: routesNames.INDUCTIONPOLICY, });
    if (hasPermission('Master', 'Induction Policy') || hasPermission('Master', 'Company') || hasPermission('Employee') || loginObj?.roleId?.some((r: number) => [1, 2, 7].includes(r))) SubMenu.push({ id: 139, label: 'Onboarding Approvals', link: routesNames.ONBOARDINGAPPROVAL, });



    SubMenu.sort((a, b) => a.label.localeCompare(b.label));
    MasterMenus.push({ id: 8, menuName: "Master", menuLogo: AdminControl, subMenu: SubMenu, });
  };

  if (hasPermission('MyDepartment'))
    Menus.push({ id: 9, menuName: "MyDepartment", menuLogo: DepartIcon, link: routesNames.MYDEPARTMENT, });


  if (hasPermission('AttendanceInfo') || hasPermission('RegularizationRequest')|| hasPermission('MyAttendanceSheet') ) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('AttendanceInfo')) SubMenu.push({ id: 1001, label: 'Attendance Info', link: routesNames.ATTENDANCEINFO, });
    if (hasPermission('RegularizationRequest')) SubMenu.push({ id: 1002, label: 'Regularization Request', link: routesNames.REGULARISATIONREQUEST, });
    if (hasPermission('RemoteRequest')) SubMenu.push({ id: 1002, label: 'Remote', link: routesNames.REMOTEREQUEST, });
    if (hasPermission('MyAttendanceSheet')) SubMenu.push({ id: 1003, label: 'MyAttendance Sheet', link: routesNames.MYATTENDANCESHEET, });
    Menus.push({ id: 10, menuName: "MyAttendance", menuLogo: MyAttendenceIcon, subMenu: SubMenu, });
  }

  if (hasPermission('LeaveApply') || hasPermission('LeaveBalances') || hasPermission('LeaveCalendar') || hasPermission('HolidayCalendar')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('LeaveApply')) SubMenu.push({ id: 111, label: 'Leave Apply', link: routesNames.LEAVEAPPLY, });
    if (hasPermission('LeaveBalances')) SubMenu.push({ id: 112, label: 'Leave Balances', link: routesNames.LEAVEBALANCES, });
    if (hasPermission('LeaveCalendar')) SubMenu.push({ id: 113, label: 'Leave Calendar', link: routesNames.LEAVECALENDAR, });
    if (hasPermission('HolidayCalendar')) SubMenu.push({ id: 114, label: 'Holiday Calendar', link: routesNames.HOLIDAYCALENDAR, });
    Menus.push({ id: 11, menuName: "MyLeaves", menuLogo: LeaveCalendarIcon, subMenu: SubMenu, });
  }

  if (hasPermission('PaySlips') || hasPermission('Form16') || hasPermission('SalaryStructureView')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('PaySlips')) SubMenu.push({ id: 121, label: 'Payslips', link: routesNames.PAYSLIPS, });
    if (hasPermission('Form16')) SubMenu.push({ id: 122, label: 'Form-16', link: routesNames.FORM16, });
    if (hasPermission('SalaryStructureView')) SubMenu.push({ id: 123, label: 'Salary Structure View', link: routesNames.SALARYSTRUCTUREVIEW, });
    Menus.push({ id: 12, menuName: "Salary&Payslip", menuLogo: AttendenceIcon, subMenu: SubMenu, });
  }

  if (hasPermission('MyTaxDeclaration') || hasPermission('MyProofofInvestment')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('MyTaxDeclaration')) SubMenu.push({ id: 131, label: 'Tax Declaration', link: routesNames.MYTAXDECLARATION, });
    if (hasPermission('MyProofofInvestment')) SubMenu.push({ id: 132, label: 'Proof Of Investment', link: routesNames.MYPROOFOFINVESTMENT, });
    Menus.push({ id: 13, menuName: "My Tax & Investment", menuLogo: TaxIcon, subMenu: SubMenu, });
  }

  if (hasPermission('Payroll'))
    Menus.push({ id: 5, menuName: "Payroll", menuLogo: PayrollIcon, link: routesNames.PAYROLL, });

  if (hasPermission('PayrollRelease'))
    Menus.push({ id: 14, menuName: "Payroll Release", menuLogo: PayrollReleaseIcon, link: routesNames.PAYROLLRELEASE, });

  if (hasPermission('MissingDocuments')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('MissingDocuments')) SubMenu.push({ id: 151, label: 'Missing Documents', link: routesNames.MISSINGDOCUMENTS, });
    Menus.push({ id: 15, menuName: "Documents", menuLogo: DocumentIcon, subMenu: SubMenu, });
  }

  if (hasPermission('RaiseTicket') || hasPermission('TicketAssignmet') || hasPermission('AssignedTicket')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('RaiseTicket')) SubMenu.push({ id: 161, label: 'Raised Ticket', link: routesNames.RAISETICKET, });
    if (hasPermission('TicketAssignmet')) SubMenu.push({ id: 162, label: 'Ticekt Assignment', link: routesNames.TICKETASSIGNMENT, });
    if (hasPermission("AssignedTicket")) SubMenu.push({ id: 163, label: 'Assigned Ticket', link: routesNames.ASSIGNEDTICKET, });
    Menus.push({ id: 16, menuName: "Support", menuLogo: SupportIcon, subMenu: SubMenu, });
  }

  if (hasPermission('Resignation Request') || hasPermission('Termination & Abscond') || hasPermission("ExitClearance") || hasPermission("Account Buyout Process") || hasPermission("Released Employee")) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Resignation Request')) SubMenu.push({ id: 170, label: 'Resignation Request', link: routesNames.RESIGNATIONAPPROVAL, });
    if (hasPermission('Released Employee')) SubMenu.push({ id: 170, label: 'Released Employee', link: routesNames.REALEASEDEMPLOYEE, });
    if (hasPermission('Termination & Abscond')) SubMenu.push({ id: 171, label: 'Terminate & Abscond', link: routesNames.TERMINATIONANDABSCOND, });
    if (hasPermission('ExitClearance')) SubMenu.push({ id: 172, label: 'Exit Clearance', link: routesNames.EXITCLEARANCE, });
    if (hasPermission('Account Buyout Process')) SubMenu.push({ id: 173, label: 'Account Buyout Process', link: routesNames.ACCOUNTSBUYOUTPROCESSING, });
    Menus.push({ id: 17, menuName: "Offboarding", menuLogo: DepartIcon, subMenu: SubMenu, });
  }


  if (hasPermission('Send Mail'))
    Menus.push({ id: 27, menuName: "Send Mail", menuLogo: AwardCerticicateIcon, link: routesNames.INTERNALMAILCOMPOSER, });

  if (hasPermission("Assets")) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Assets', 'Dashboard')) SubMenu.push({ id: 281, label: 'Asset Dashboard', link: routesNames.ASSETDASHBOARD, });
    if (hasPermission('Assets', 'Asset Stock')) SubMenu.push({ id: 288, label: 'Asset Stock', link: routesNames.ASSETSTOCK, });
    if (hasPermission('Assets', 'Procurement')) SubMenu.push({ id: 282, label: 'Asset Procurement', link: routesNames.ASSETPROCUREMENT, });
    if (hasPermission('Assets', 'Asset Entry')) SubMenu.push({ id: 283, label: 'Asset Entry', link: routesNames.ASSETENTRY, });
    // if (hasPermission('Assets', 'Procurement')) SubMenu.push({ id: 283, label: 'Inventory Allocation', link: routesNames.INVENTORYALLOCATION, });
    if (hasPermission('Assets', 'Asset Request')) SubMenu.push({ id: 284, label: 'Asset Request', link: routesNames.ASSETREQUEST, });
    if (hasPermission('Assets', 'Asset Assignment')) SubMenu.push({ id: 285, label: 'Asset Assignment', link: routesNames.ASSETASSIGNMENT, });
    if (hasPermission('Assets', 'Asset Return')) SubMenu.push({ id: 286, label: 'Asset Return', link: routesNames.ASSETRETURN, });
    if (hasPermission('Assets', 'Asset Recovery') || hasPermission('Assets', 'AllRecovery') || hasPermission('Assets', 'BranchRecovery') || hasPermission('Assets', 'ViewAllRecovery') || hasPermission('Assets', 'ViewBranchRecovery')) {
      SubMenu.push({ id: 289, label: 'Asset Recovery', link: routesNames.ASSETRECOVERY, });
    }
    if (hasPermission('Assets', 'Asset Maintenance')) SubMenu.push({ id: 286, label: 'Asset Maintenance', link: routesNames.ASSETMAINTENANCE, });
    if (hasPermission('Assets', 'Asset Disposal')) SubMenu.push({ id: 287, label: 'Asset Disposal/Scrap', link: routesNames.ASSETDISPOSAL, });
    Menus.push({ id: 28, menuName: "Asset", menuLogo: AssetICon, subMenu: SubMenu, });
  }

  if (hasPermission('Award&Certificate'))
    Menus.push({ id: 23, menuName: "Award & Certificate", menuLogo: AwardCerticicateIcon, link: routesNames.ADMINCERTIFICATE, });

  if (hasPermission('MyAward'))
    Menus.push({ id: 24, menuName: "My Certificate", menuLogo: AwardCerticicateIcon, link: routesNames.MYAWARD, });



  if (hasPermission('MyTask') || hasPermission('Task List') || hasPermission('Employee Task List')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('MyTask')) SubMenu.push({ id: 250, label: ' My Task', link: routesNames.MYTASK, });
    if (hasPermission('Task List')) SubMenu.push({ id: 251, label: ' Task List', link: routesNames.TASKLIST, });
    if (hasPermission('Employee Task List')) SubMenu.push({ id: 252, label: ' Employee Task List', link: routesNames.EMPLOYEETASKLIST, });

    Menus.push({ id: 25, menuName: "Task", menuLogo: TaskIcon, subMenu: SubMenu, });
  }


  if (hasPermission('Docs'))
    Menus.push({ id: 26, menuName: "Docs", menuLogo: DepartIcon, link: routesNames.DOCS, });


  ////
  //Recruitment Tab start from here add permission here 
  ///
  ////

  if (hasPermission('RecruitmentDashboard'))
    RequirementMenus.push({ id: 1, menuName: "Dashboard", menuLogo: HomeIcon, link: routesNames.RecruitmentDashboard, });

  if (hasPermission('ActiveJobs') || hasPermission('ClosedJobs')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('ActiveJobs')) SubMenu.push({ id: 21, label: 'Active Jobs', link: routesNames.ACTIVEJOBS, });
    if (hasPermission('ClosedJobs')) SubMenu.push({ id: 22, label: 'Closed Jobs', link: routesNames.CLOSEDJOBS, });

    RequirementMenus.push({ id: 2, menuName: "Job Openings", menuLogo: JobOpeningIcon, subMenu: SubMenu, });
  }
  if (hasPermission('OffersOnBording') || loginObj?.roleId?.some((r: number) => [1, 2, 7].includes(r))) {
    const SubMenu: SubMenuItem[] = [];
    SubMenu.push({ id: 31, label: 'Candidate Onboarding', link: routesNames.ONBOARDINGCANDIDATELIST, });
    SubMenu.push({ id: 32, label: 'Onboarding Approvals', link: routesNames.ONBOARDINGAPPROVAL, });
    RequirementMenus.push({ id: 3, menuName: "Offers & Onboarding", menuLogo: OnboardingIcon, subMenu: SubMenu, });
  }

  RequirementMenus.push({ id: 5, menuName: "Welcome Mail", menuLogo: Welcomeicon, link: routesNames.WELCOMEMAIL, });
  // if (hasPermission('Report')) {
  if (hasPermission('Candidate Report') || hasPermission('Ivr Report')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Candidate Report')) SubMenu.push({ id: 41, label: 'Candidate Report', link: routesNames.CANDIDATEREPORT });
    if (hasPermission('Ivr Report')) SubMenu.push({ id: 42, label: 'IVR Report', link: routesNames.IVRREPORT });
    RequirementMenus.push({ id: 4, menuName: "Report", menuLogo: ReportIcon, subMenu: SubMenu, });
  }
  // }

  if (hasPermission("ConsumerDashboard")) {
    ConsumerMenus.push({ id: 1, menuName: "Dashboard", menuLogo: EmployeeIcon, link: routesNames.CONSUMERDASHBOARD, });
  }

  const ActiveMenu = isMasterRoute ? MasterMenus : menus;
  const navigate = useNavigate();
  useEffect(() => {
    const activeItem = ActiveMenu.find(
      (item) =>
        item.link === location.pathname ||
        item.subMenu?.some((sub) => sub.link === location.pathname)
    );
    if (activeItem) {
      setMenuId(activeItem.id);
    }
  }, [location.pathname, ActiveMenu]);

  const handleMenu = (itemId: number) => {
    const selectedItem = ActiveMenu.find(item => item.id === itemId);

    // If clicking the same menu item that's already active
    if (menuId === itemId) {
      // If it has submenus, keep it expanded (don't toggle)
      if (selectedItem?.subMenu) {
        return;
      }
      // If it doesn't have submenus, keep it selected
      return;
    }

    // If the menu has a subMenu and no subMenu is currently active, redirect to its first submenu
    if (
      selectedItem?.subMenu &&
      !selectedItem.subMenu.some((sub) => sub.link === location.pathname)
    ) {
      const firstSubLink = selectedItem.subMenu[0]?.link;
      if (firstSubLink) {
        window.history.pushState({}, '', firstSubLink);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }

    setMenuId(itemId);
  };

  // const handleLogoClick = () => {
  //   if (props.activePortal === "hrlense") {
  //     navigate(routesNames.DASHBOARD);
  //   } else {
  //     navigate(routesNames.RecruitmentDashboard);
  //   }
  // };
  const handleLogoClick = () => {
    if (props.activePortal === "hrlense") {
      navigate(routesNames.DASHBOARD);
    } else if (props.activePortal === "Recruitment") {
      navigate(routesNames.RecruitmentDashboard);
    } else if (props.activePortal === "consumer") {
      navigate(routesNames.CONSUMERDASHBOARD);
    }
  };

  return (
    <MyDiv>
      <Box className={props.toggleSidebar ? "sidebar_collapse" : "sidebar_wrapper"}>
        <Box className="collapse-button">
          <IconButton className={props.toggleSidebar ? "" : "collpase_icon"} onClick={props.handleSidePanel} icon={<Image src={CollapseIcon} w={"30px"} />} aria-label={""} />
        </Box>
        <Box>
          <Flex className="top_header" style={{ justifyContent: props.toggleSidebar ? "center" : "" }}>
            {props.toggleSidebar ? (
              <Image src={CollapseLogo} className="col" cursor={'pointer'} onClick={handleLogoClick} />
            ) : (
              <Image src={Logo} className="logo" cursor={'pointer'} onClick={handleLogoClick} />
            )}
          </Flex>
          <Box className={props.toggleSidebar ? "sidebar_box_toggle" : "sidebar_box"}>
            <Stack spacing="3" className="menu_box">
              {ActiveMenu.map((item) => {
                const isActiveMenu = item.id === menuId;
                const hasSubMenu = item.subMenu?.length;
                const isExpanded = isActiveMenu && hasSubMenu;

                return (
                  <Box key={item.id}>
                    <Flex className={isActiveMenu ? "active_menu menu_item" : "menu_item"} onClick={() => handleMenu(item.id)}>
                      <NavLink to={item.link ?? ""} className="font-poppins font_dark" style={{ justifyContent: props.toggleSidebar ? "center" : "" }}>
                        <Image src={item.menuLogo} className="icon_size" />
                        {!props.toggleSidebar && item.menuName}
                      </NavLink>
                    </Flex>

                    {isExpanded && !props.toggleSidebar && (
                      <Box className="submenu_wrapper">
                        {item.subMenu?.map((subItem) => {
                          const isSubActive = location.pathname === subItem.link;
                          return (
                            <NavLink key={subItem.id} to={subItem.link} className={isSubActive ? "active_submenu submenu_item" : "submenu_item"}>
                              • {subItem.label}
                            </NavLink>
                          );
                        })}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Stack>
          </Box>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default Sidebar;